/**
 * QuickStart information for Weave product.
 */

import {Button} from '@wandb/weave/components';
import {IconChevronNext} from '@wandb/weave/components/Icon';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';
import {useHistory} from 'react-router-dom';

import weavePlaygroundQuickstart from '../../../assets/screenshots/weave_playground_quickstart_2.png';
import {useUpsertModelMutation} from '../../../generated/graphql';
import * as Track from '../../../services/analytics';
import {QuickStartAnalyticsOrigin} from '../../../services/analytics/quickStartEvents';
import {doNotRetryContext, propagateErrorsContext} from '../../../util/errors';
import {AccessOption} from '../../../util/permissions';

type QuickStartWeaveProps = {
  entityName: string;
  projectName: string;
  analyticsOrigin: QuickStartAnalyticsOrigin;
};

// TODO: ask product if we can change this to a more descriptive name
const QUICKSTART_PROJECT_NAME = 'quickstart_playground';

export const QuickStartWeavePlayground = ({
  entityName,
  projectName,
  analyticsOrigin,
}: QuickStartWeaveProps) => {
  const [upsertProjectMutation] = useUpsertModelMutation({
    context: propagateErrorsContext(),
    ...doNotRetryContext(),
  });
  const history = useHistory();
  return (
    <>
      <Tailwind className="h-screen">
        <div className="my-20 rounded-lg bg-moon-150 p-8">
          <img src={weavePlaygroundQuickstart}></img>
        </div>
        <div className="h-screen">
          <div className="flex w-[800px] content-start justify-between">
            <div className="my-6 flex-initial">
              <Button
                size="medium"
                onClick={async () => {
                  let projectNameToGoTo = projectName;
                  try {
                    if (projectNameToGoTo === '') {
                      Track.clickedWeavePlayground({
                        projectName,
                        entityName,
                        location: analyticsOrigin,
                      });
                      projectNameToGoTo = QUICKSTART_PROJECT_NAME;
                      await upsertProjectMutation({
                        variables: {
                          description: QUICKSTART_PROJECT_NAME,
                          access: AccessOption.Private,
                          name: projectNameToGoTo,
                          entityName,
                        },
                      });
                    }
                    history.push(
                      `/${entityName}/${projectNameToGoTo}/weave/playground`
                    );
                  } catch (e) {
                    console.error(e);
                  }
                }}>
                <>
                  Start Exploring <IconChevronNext />
                </>
              </Button>
            </div>
          </div>
        </div>
      </Tailwind>
    </>
  );
};
